import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setError, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PEDIDO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PEDIDO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'PEDIDO_SET_FILTRO',
        payload: filtro
    };
}

export function initForm(registro = {}) {
    return [
        initialize('pedidoForm', registro)
    ];
}

export function getLista() {

	return (dispatch, getState) => {

		let filtro = `?data_inicial=${DateFormat.formatarDataTelaParaParametro(DateFormat.formatarDataSqlParaTela(getState().pedido.filtro.dataInicial))}`;
		filtro += `&data_final=${DateFormat.formatarDataTelaParaParametro(DateFormat.formatarDataSqlParaTela(getState().pedido.filtro.dataFinal))}`;
		filtro += getState().pedido.filtro.idFornecedor ? `&id_fornecedor=${getState().pedido.filtro.idFornecedor}` : '';
		filtro += getState().pedido.filtro.idCliente ? `&id_cliente=${getState().pedido.filtro.idCliente}` : '';
		filtro += getState().pedido.filtro.situacoes ? `&situacoes=${getState().pedido.filtro.situacoes}` : '';
		
	    axios.get(`${consts.API_URL}/pedido${filtro}`).then(resp => {
			dispatch({
				type: 'PEDIDO_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaSolicitacaoAberta() {
	return (dispatch, getState) => {
	    axios.get(`${consts.API_URL}/solicitacaoCompra?apenas_abertas=true`).then(resp => {
			dispatch({
				type: 'PEDIDO_SOLICITACAO_COMPRA_ABERTA_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return async (dispatch, getState) => {
		if (!registro.id) {
	        await axios.post(`${consts.API_URL}/pedido`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				setSuccess('Operação Realizada com sucesso.');

				for (let i = 0; i < registro.listaSolicitacoesSelecionadas.length; i++) {
					const solicitacao = registro.listaSolicitacoesSelecionadas[i];

					await axios.post(`${consts.API_URL}/pedidoItem`, {
						id_pedido: resp.data.id,
						id_solicitacao: solicitacao.id,
						quantidade: solicitacao.quantidade,
						id_usuario_inclusao: getState().auth.usuario.id,
						id_usuario_alteracao: getState().auth.usuario.id
					}).then(resp => {
						
					}).catch(e => {
						console.log(e);
					});					
				}

				dispatch(getLista());
				dispatch(getListaSolicitacaoAberta());
				dispatch(getListaItens(resp.data.id));
				dispatch(getListaHistoricos(resp.data.id));
				dispatch(initForm({
					...resp.data,
					listaSolicitacoesSelecionadas: null
				}));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/pedido`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedido?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

//Itens

export function initFormItem(registro = {}) {
    return [
        initialize('pedidoItemForm', registro)
    ];
}

export function getListaItens(idPedido) {
	return (dispatch, getState) => {
	    axios.get(`${consts.API_URL}/pedidoItem?id_pedido=${idPedido}`).then(resp => {
			dispatch({
				type: 'PEDIDO_ITEM_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarItem(registro) {
    return async (dispatch, getState) => {
		if (registro.listaSolicitacoesSelecionadas) {
			
			for (let i = 0; i < registro.listaSolicitacoesSelecionadas.length; i++) {

				const solicitacao = registro.listaSolicitacoesSelecionadas[i];

				await axios.post(`${consts.API_URL}/pedidoItem`, {
					id_pedido: registro.id,
					id_solicitacao: solicitacao.id,
					quantidade: solicitacao.quantidade,
					id_usuario_inclusao: getState().auth.usuario.id,
					id_usuario_alteracao: getState().auth.usuario.id
				}).then(resp => {
					
				}).catch(e => {
					console.log(e);
				});					
			}

			dispatch(getLista());
			dispatch(getListaSolicitacaoAberta());
			dispatch(getListaItens(registro.id));
			dispatch(getListaHistoricos(registro.id));
			dispatch(initForm({
				...registro,
				listaSolicitacoesSelecionadas: null
			}));
		} else {
			console.log(registro);
			axios.put(`${consts.API_URL}/pedidoItem`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
				valor_frete: FormatUtils.formatarValorBanco(registro.valor_frete, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaItens(registro.id_pedido));
				dispatch(initFormItem(null));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluirItem(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedidoItem?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaItens(registro.id_pedido));
			dispatch(getListaHistoricos(registro.id_pedido));
			dispatch(getListaSolicitacaoAberta());
			dispatch(initFormItem(null));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function duplicarItem(registro, evento) {
    return async (dispatch, getState) => {

		let quantidadeOriginal = parseFloat(registro.quantidade || 0);
		let quantidadeNova = parseFloat(registro.nova_quantidade || 0);

		if (quantidadeNova > quantidadeOriginal) {
			setError('Quantidade da nova solicitação não pode ser maior que a da origem');
			return;
		} else if (quantidadeNova == quantidadeOriginal) {
			setError('Quantidade da solicitação de origem não pode ficar zerada');
			return;
		} else if (quantidadeNova <= 0) {
			setError('Quantidade da nova solicitação deve ser maior que zero');
			return;
		}

		//Carrega a solicitação original
		let solicitacaoOrigem = null;
		await axios.get(`${consts.API_URL}/solicitacaoCompra?id=${registro.id_solicitacao}`).then(resp => {
			solicitacaoOrigem = resp.data[0];
		}).catch(e => {
			setErroAPI(e);
		});

		if (!solicitacaoOrigem) {
			return;
		}

		//Cria a nova solicitação
		let solicitacaoNova = null;
		await axios.post(`${consts.API_URL}/solicitacaoCompra`, {
			...solicitacaoOrigem,
			quantidade: quantidadeNova,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			solicitacaoNova = resp.data;
		}).catch(e => {
			setErroAPI(e);
		});

		if (!solicitacaoNova) {
			return;
		}

		//Altera a solicitação de origem
		await axios.put(`${consts.API_URL}/solicitacaoCompra`, {
			...solicitacaoOrigem,
			quantidade: quantidadeOriginal - quantidadeNova,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			
		}).catch(e => {
			setErroAPI(e);
		});

		//Cria o novo pedido
		axios.post(`${consts.API_URL}/pedidoItem`, {
			...registro,
			id_solicitacao: solicitacaoNova.id,
			quantidade: quantidadeNova,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			
		}).catch(e => {
			setErroAPI(e);
		});

		//Altera pedido de origem
		axios.put(`${consts.API_URL}/pedidoItem`, {
			...registro,
			quantidade: quantidadeOriginal - quantidadeNova,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			
		}).catch(e => {
			setErroAPI(e);
		});

		setSuccess('Operação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(getListaItens(registro.id_pedido));
		evento();			
    };
}

//Histórico

export function initFormHistorico(registro = {}) {
    return [
        initialize('pedidoHistoricoForm', registro)
    ];
}

export function getListaHistoricos(idPedido) {
	return (dispatch, getState) => {
		dispatch({
			type: 'PEDIDO_HISTORICO_LISTADO',
			payload: {
				data: []
			}
		});

	    axios.get(`${consts.API_URL}/pedidoHistorico?id_pedido=${idPedido || 0}`).then(resp => {
			dispatch({
				type: 'PEDIDO_HISTORICO_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarHistorico(registro) {
    return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/pedidoHistorico`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaHistoricos(registro.id_pedido));
				dispatch(initFormHistorico(null));		
			}).catch(e => {
				setErroAPI(e);
			});					
		} else {
			axios.put(`${consts.API_URL}/pedidoHistorico`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaHistoricos(registro.id_pedido));
				dispatch(initFormHistorico(null));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluirHistorico(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedidoHistorico?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaHistoricos(registro.id_pedido));
			dispatch(initFormHistorico(null));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

//Cotações
export function initFormCotacao(registro = {}) {
    return [
        initialize('pedidoCotacaoForm', registro)
    ];
}

export function getListaCotacoes(idPedido) {
	return (dispatch, getState) => {
		dispatch({
			type: 'PEDIDO_COTACAO_LISTADO',
			payload: {
				data: []
			}
		});

	    axios.get(`${consts.API_URL}/solicitacaoCompraCotacao?id_pedido=${idPedido}`).then(resp => {
			dispatch({
				type: 'PEDIDO_COTACAO_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarCotacao(registro) {
    return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/solicitacaoCompraCotacao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				valor_unitario: FormatUtils.formatarValorBanco(registro.valor_unitario, 2),
				percentual_ipi: FormatUtils.formatarValorBanco(registro.percentual_ipi, 2),
				percentual_icms: FormatUtils.formatarValorBanco(registro.percentual_icms, 2),
				valor_desconto: FormatUtils.formatarValorBanco(registro.valor_desconto, 2),
				aliquota_icms_rs: FormatUtils.formatarValorBanco(registro.aliquota_icms_rs, 2),
				valor_frete: FormatUtils.formatarValorBanco(registro.valor_frete, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getListaCotacoes(registro.id_pedido));
				dispatch(initFormCotacao(null));		
			}).catch(e => {
				setErroAPI(e);
			});					
		} else {
			axios.put(`${consts.API_URL}/solicitacaoCompraCotacao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				valor_unitario: FormatUtils.formatarValorBanco(registro.valor_unitario, 2),
				percentual_ipi: FormatUtils.formatarValorBanco(registro.percentual_ipi, 2),
				percentual_icms: FormatUtils.formatarValorBanco(registro.percentual_icms, 2),
				valor_desconto: FormatUtils.formatarValorBanco(registro.valor_desconto, 2),
				aliquota_icms_rs: FormatUtils.formatarValorBanco(registro.aliquota_icms_rs, 2),
				valor_frete: FormatUtils.formatarValorBanco(registro.valor_frete, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getListaCotacoes(registro.id_pedido));
				dispatch(initFormCotacao(null));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluirCotacao(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/solicitacaoCompraCotacao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaCotacoes(registro.id_pedido));
			dispatch(initFormCotacao(null));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaFreteTipo() {
	return (dispatch, getState) => {
	    axios.get(`${consts.API_URL}/freteTipo/listarselect`).then(resp => {
			dispatch({
				type: 'PEDIDO_FRETE_TIPO_SELECT_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function imprimir(registro) {
	return (dispatch, getState) => {

	    axios.post(`${consts.API_URL}/pedido/imprimir`, {
			...registro,
			datahora_pedido: DateFormat.formatarDataHoraSqlParaTela(registro.datahora_pedido),
			lista: registro.lista.map(item => ({
				...item,
				quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
				valor: FormatUtils.formatarValorTela(item.valor, 2),
				valor_total: FormatUtils.formatarValorTela(parseFloat(item.valor || 0) * parseFloat(item.quantidade || 0), 2),
				valor_frete: FormatUtils.formatarValorTela(item.valor_frete || 0, 2),
				data_previsao_entrega: item.data_previsao_entrega ? DateFormat.formatarDataSqlParaTela(item.data_previsao_entrega) : 'Não Informada'
			}))
		}).then(resp => {
			window.open(`${consts.URL}/${resp.data}`, '_blank');
		}).catch(ex => {
			console.log(ex);
		});

	}
}

export function getListaProdutoHistorico(filtro) {
	return (dispatch, getState) => {
	    axios.get(`${consts.API_URL}/pedidoItem/historico?id_produto=${filtro.id_produto}&id_pedido=${filtro.id_pedido}`).then(resp => {
			dispatch({
				type: 'PEDIDO_PRODUTO_HISTORICO_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}